import React, { Component } from 'react';
import styles from './index.module.scss';
import axios from "@/util/axios";
import { api } from "@/routes/api";
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';

@connect(
  null,
  { changeLoading }
)
class Detail extends Component {
  state = {
    info: {},
    ambulance: ''
  }
  componentDidMount = () => {
    this.getNewsInfo();
  }
  getNewsInfo = async () => {
    this.props.changeLoading(true);
    const pathname = this.props.location.pathname.split("/");
    const res = await axios.post(api.getNewsInfo, { id: pathname[pathname.length - 1] });
    const { data, ambulance } = res;
    this.setState({ info: data, ambulance });
    setTimeout(() => this.props.changeLoading(false), 500);
  }
  render() {
    const { info } = this.state;
    return (
      <div>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.detail_container}>
          <div className={styles.title}>{info.title}</div>
          <div className={styles.time}>{info.create_time}</div>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: info.content }} />
        </div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Detail;
